const marquee = document.querySelector(".marquee");

function checkMarquee() {
	// Force a reflow calculation by accessing offsetWidth
	const marqueeContent = document.querySelector(".marquee-content");
	const marqueeContainer = document.querySelector(".marquee-container");
	const contentWidth = marqueeContent.scrollWidth; // Use scrollWidth for the full content width
	const containerWidth = marqueeContainer.offsetWidth;

	// Check if the content width exceeds the container's width
	if (contentWidth > containerWidth) {
		marquee.classList.add("marquee");
	} else {
		marquee.classList.remove("marquee");
	}
}

if (marquee) {
	// Perform the check upon loading
	checkMarquee();

	// Re-evaluate when the window is resized
	window.addEventListener("resize", checkMarquee);
}
